import React from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa"; // Import icons

export default function DeleteAccountPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      {/* Logo Section */}
      <div className="text-center mb-8">
        <img src="/logo.png" alt="Logo" className="w-32 h-auto mx-auto" />
      </div>

      <h1 className="text-4xl font-bold mb-8 text-center text-green-600">Contact Us At:</h1>

      <div className="text-center mb-8">
        <div className="flex items-center justify-center mb-6">
          <FaPhoneAlt className="text-2xl mr-3 text-green-600" />
          <span className="text-lg text-gray-800">+95 9448831872</span>
        </div>
        <div className="flex items-center justify-center">
          <FaEnvelope className="text-2xl mr-3 text-green-600" />
          <span className="text-lg text-gray-800">info@msmebyg3g.com</span>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="text-center mt-16 text-sm text-gray-500">
        <p>&copy; {new Date().getFullYear()} MSME. All Rights Reserved.</p>
      </footer>
    </div>
  );
}
